import { RcFile } from 'antd/lib/upload';
import axios from 'axios';
import { BLOB_TYPE } from 'views/CompanyDashboard/constants';

export const getFileNameFromS3Url = (fileUrl: string): string => {
  const urlWithoutQuery = fileUrl.split('?')[0];
  return urlWithoutQuery.substring(urlWithoutQuery.lastIndexOf('/') + 1);
};

export const fetchFileAsRcFile = async (fileUrl: string) => {
  const fileName = getFileNameFromS3Url(fileUrl);
  try {
    const { data: fileBlob } = await axios.get(fileUrl, {
      responseType: BLOB_TYPE,
    });

    const rcFile = new File([fileBlob], fileName, {
      type: fileBlob.type,
      lastModified: Date.now(),
    }) as RcFile;

    rcFile.uid = Date.now().toString();

    return rcFile;
  } catch (error) {}
};
